document.addEventListener('DOMContentLoaded', function(){
  var steps = document.querySelectorAll('[data-kby-step]');

  function setStepHeight(step, open){
    var panel = step.querySelector('.kby-step__panel');
    panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
  }

  steps.forEach(function(step){
    var row = step.querySelector('.kby-step__row');
    if(step.classList.contains('is-active')) setStepHeight(step, true);

    row.addEventListener('click', function(){
      var wasActive = step.classList.contains('is-active');
      steps.forEach(function(s){
        s.classList.remove('is-active');
        s.querySelector('.kby-step__row').setAttribute('aria-expanded', 'false');
        setStepHeight(s, false);
      });
      if(!wasActive){
        step.classList.add('is-active');
        row.setAttribute('aria-expanded', 'true');
        setStepHeight(step, true);
      }
    });
  });

  function showCustomCopiedWindow() {
    var popup = document.createElement('div');
    popup.textContent = 'Copied';
    popup.style.position = 'fixed';
    popup.style.top = '50%';
    popup.style.left = '50%';
    popup.style.transform = 'translate(-50%, -50%)';
    popup.style.backgroundColor = '#111820';
    popup.style.color = '#ffffff';
    popup.style.padding = '20px 40px';
    popup.style.borderRadius = '12px';
    popup.style.zIndex = '999999';
    popup.style.fontSize = '18px';
    popup.style.fontWeight = 'bold';
    popup.style.boxShadow = '0 10px 30px rgba(0,0,0,0.3)';
    document.body.appendChild(popup);
    setTimeout(function(){ document.body.removeChild(popup); }, 1500);
  }

  var copyBtn = document.getElementById('kby-copy-code');
  if(copyBtn){
    copyBtn.addEventListener('click', function(e){
      e.preventDefault();
      var codeToCopy = copyBtn.dataset.code || 'KNOWBEFOREYOUGO';
      
      function fallbackCopyTextToClipboard(text) {
        var textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position = "fixed";
        textArea.style.top = "0";
        textArea.style.left = "0";
        textArea.style.opacity = "0";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        
        try {
          document.execCommand('copy');
          showCustomCopiedWindow();
          var original = copyBtn.textContent;
          copyBtn.textContent = 'Copied';
          setTimeout(function(){ copyBtn.textContent = original; }, 1500);
        } catch (err) {}
        document.body.removeChild(textArea);
      }

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(codeToCopy).then(function(){
          showCustomCopiedWindow();
          var original = copyBtn.textContent;
          copyBtn.textContent = 'Copied';
          setTimeout(function(){ copyBtn.textContent = original; }, 1500);
        }).catch(function() {
          fallbackCopyTextToClipboard(codeToCopy);
        });
      } else {
        fallbackCopyTextToClipboard(codeToCopy);
      }
    });
  }
});